// @flow

import { Base } from '@gandi/ui';

import styles from './DurationRowBanner.scss';

type Props = {
  children: React.Node,
};
export function DurationRowBanner({ children }: Props): React.MixedElement {
  return (
    <Base flex flexAlignItemsCenter className={styles.root}>
      {children}
    </Base>
  );
}
